"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomAxiosError = exports.sleep = exports.getExtendedAxios = void 0;
const axios_1 = require("axios");
const _ = require("lodash");
function getExtendedAxios(config = {}) {
    const instance = axios_1.default.create(config.axiosConfig || {});
    if (config.mediator) {
        configureRefreshableAuth(instance, config.mediator);
    }
    if (config.retrier) {
        configureWithRetrier(instance, config.retrier);
    }
    configureWithCustomAxiosError(instance);
    return instance;
}
exports.getExtendedAxios = getExtendedAxios;
function configureRefreshableAuth(instance, mediator) {
    instance.interceptors.request.use(async function (config) {
        var _a;
        const expiryTime = await ((_a = mediator.getExpiryTime) === null || _a === void 0 ? void 0 : _a.call(mediator));
        if (!_.isNil(expiryTime)) {
            const timeToExpire = mediator.TimeToExpire ? mediator.TimeToExpire : 1800;
            const tokenIsAboutToExpire = expiryTime - Date.now() < timeToExpire;
            if (tokenIsAboutToExpire) {
                let refreshData;
                if (!_.isNil(mediator.getRefreshCallback)) {
                    refreshData = await mediator.getRefreshCallback();
                }
                else {
                    const { url, auth, headers, params, data = undefined } = await mediator.getRefreshConfig();
                    //use a different instance for this request
                    const response = await axios_1.default.post(url, data, { auth, headers, params });
                    refreshData = response.data;
                }
                await mediator.saveAuthCredentials(refreshData);
            }
        }
        const { headers, params } = await mediator.getAuthCredentials();
        config.headers = { ...config.headers, ...headers };
        config.params = { ...config.params, ...params };
        // config.data = {...config.data, ...data};
        return config;
    });
}
function configureWithRetrier(instance, retrier) {
    let attemtsWitError = 0;
    instance.interceptors.response.use(null, async function (error) {
        attemtsWitError++;
        // some error must be empty, like bad url
        if (error && error.response && error.config) {
            const backoff = retrier.getBackoff(error, attemtsWitError);
            console.log(`url: ${error.config.url}, status: ${error.response.status}, attempts: ${attemtsWitError}, backoff: ${backoff}`);
            if (backoff >= 0) {
                if (backoff > 0) {
                    await sleep(backoff); //we only sleep if backoff != 0
                }
                return instance.request(error.config);
            }
        }
        attemtsWitError = 0;
        throw error;
    });
}
async function sleep(ms) {
    await new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
exports.sleep = sleep;
function configureWithCustomAxiosError(instance) {
    instance.interceptors.response.use(null, async function (error) {
        throw new CustomAxiosError(error);
    });
}
class CustomAxiosError extends Error {
    constructor(error) {
        if (error && error.config && error.response) {
            const { url, method, params } = error.config;
            const { status, data } = error.response;
            super(`method: ${method}, url: ${url}, status: ${status}, message: ${error.message}`);
            this.response = { status, data };
            this.config = { method, url, params };
        }
        else {
            super(error.message);
        }
        this.resume = error ? error.toString() : undefined;
    }
    toString() {
        return this.resume;
    }
}
exports.CustomAxiosError = CustomAxiosError;
//# sourceMappingURL=axios-helper.js.map